import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.gray.gray70,
      margin: theme.spacing(0, 1),
    },
  }),
  { name: 'ItemDivider' }
);
